import {
    EventQueueRowData,
    ScheduledEventQueueRowData,
    UnitQueueRowData,
} from '../../socket/stream-types';

export function dataIsUnitQueueView(
    data: EventQueueRowData | UnitQueueRowData | ScheduledEventQueueRowData
): data is UnitQueueRowData {
    // hasBackups will _always_ have a value and so is a good value to rely
    // on for this duck typing - any value which is potentially undefined has
    // (like the previously used `eventQueueView`) is liable to give us an
    // incorrect return from this function
    if ('hasBackups' in data) {
        return true;
    }
    return false;
}

export function getEventQueueRowData(
    data: EventQueueRowData | UnitQueueRowData
): EventQueueRowData | undefined {
    if (dataIsUnitQueueView(data)) {
        return data.eventQueueView;
    }
    return data;
}

export function getEventQueueRowDataOrScheduledEventQueueRowData(
    data: EventQueueRowData | UnitQueueRowData | ScheduledEventQueueRowData
): EventQueueRowData | ScheduledEventQueueRowData | undefined {
    if (dataIsUnitQueueView(data)) {
        return data.eventQueueView;
    }
    return data;
}
